import { render } from "./RemainingVacationDetail.vue?vue&type=template&id=281b2a3d"
import script from "./RemainingVacationDetail.vue?vue&type=script&lang=js"
export * from "./RemainingVacationDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\leeten-hrm-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__